import { useEffect, useState } from "react";
import { isBlackPublicOpen } from "@/lib/black2x1/offer-rules";

/** Stable hydration, live rollover even on pages left open before launch. */
export function useBlackSale() {
  const [sale, setSale] = useState(false);
  useEffect(() => {
    const update = () => setSale(isBlackPublicOpen(Date.now()));
    update();
    const timer = window.setInterval(update, 1000);
    return () => window.clearInterval(timer);
  }, []);
  return sale;
}